import { render, staticRenderFns } from "./SettlementOwnerEmailIcon.vue?vue&type=template&id=0035e4de&scoped=true&"
import script from "./SettlementOwnerEmailIcon.vue?vue&type=script&lang=js&"
export * from "./SettlementOwnerEmailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035e4de",
  null
  
)

export default component.exports